<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getAlarmData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Alarm
        </a>
      </div>
    </div>
    <div class="card card-details">
      <p class="error"  v-if="getFormError()">

      </p>
      <p class="error"  v-else>
      </p>
      <DeleteAlarmComponent
              :id = parseInt(id)
              :current_site_code = getAlarmData().site_code
              :current_seu = getAlarmData().seu
              :current_enpi = getAlarmData().enpi
      />
    </div>
  </div>
</div>
</template>


<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory } from "@/common/general.js";
import DeleteAlarmComponent from "@/components/alarms/DeleteAlarmComponent.vue";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"

export default {
  name: "AlarmDelete",
  components: {
    DeleteAlarmComponent,
    NoPermissionComponent,
  },
  props: {
    id: { type: Number, required: true },
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapGetters(["getAlarmData","getFormError", "getUsername", "isLoggedIn"]),
    ...mapActions(["fetchAlarmData", "performSetFormError"]),
    hasHistory: hasHistory,
    getAlarmDetails() {
      this.fetchAlarmData({"id": this.id })
    },
  },

  created() {
    this.getAlarmDetails();
    this.performSetFormError(null);
    document.title = "Delete Alarm";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.getAlarmDetails();
    next();
  }
}


</script>
